import { Stack } from '@qred/components-library';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import SpinnerCircular from '~/components/shared/Spinner/SpinnerCircular';
import { CountryCode, FlowTypes } from '~/enums';
import { areSameCompanies } from '~/helpers/utils';
import { useAppDispatch } from '~/hooks/useAppDispatch';
import { RootState } from '~/store';
import { setCompanyIsNew } from '~/store/slices/loanApplication.slice';
import { ApiStatus } from '~/store/types/sharedTypes';
import {
  StandardStepContent,
  StandardStepContentBody,
  StandardStepContentFooter,
} from '~/styles/BaseStyledComponents';
import { theme } from '~/styles/themes';
import CompanySearch from './components/CompanySearch';
import { CompanySearchGermany } from './components/CompanySearchGermany';
import CompanySelectorFooter from './components/CompanySelectorFooter';
import CompanySelectorHeader from './components/CompanySelectorHeader';
import CompanySelectorRadioButtons from './components/CompanySelectorRadioButtons';

const CompanySelector = () => {
  const dispatch = useAppDispatch();

  const {
    form,
    apiStatus,
    overview,
    companyIsNew,
    flowType,
    userId,
  } = useSelector((state: RootState) => state.loanApplication);
  const { market } = useSelector((state: RootState) => state.intl);

  // IMPORTANT TODO: we need to set companyIsNew to true if user in auth flow has
  // new company and reloads page and goes back to company selector
  useEffect(() => {
    const isAuthenticatedNlc =
      flowType === FlowTypes.Authenticated &&
      form.organizationNumber &&
      apiStatus.clients === ApiStatus.Completed &&
      !overview.clients.some((client) =>
        areSameCompanies(
          client.company_no || client.connect_id,
          form.organizationNumber || form.connectId
        )
      );

    if (flowType === FlowTypes.Manual || !userId || isAuthenticatedNlc) {
      dispatch(setCompanyIsNew(true));
    }
  }, []);

  return (
    <StandardStepContent>
      <StandardStepContentBody>
        <CompanySelectorHeader />
        {apiStatus.clients !== ApiStatus.Started ? (
          <Stack spacing="xxl">
            {apiStatus.clients === ApiStatus.Completed &&
              !!overview.clients?.length && (
                <Stack spacing="xs">
                  <CompanySelectorRadioButtons clients={overview.clients} />
                </Stack>
              )}

            {companyIsNew && (
              <>
                {market === CountryCode.DE ? (
                  <CompanySearchGermany />
                ) : (
                  <CompanySearch />
                )}
              </>
            )}
          </Stack>
        ) : (
          <SpinnerCircular color={theme.colors.secondaryGray} />
        )}
      </StandardStepContentBody>
      <StandardStepContentFooter>
        <CompanySelectorFooter />
      </StandardStepContentFooter>
    </StandardStepContent>
  );
};
export default CompanySelector;
